export default __webpack_public_path__ + "static/apple-touch-icon-f48bbb0972c83363f01d0c056e0c6e76.png";